import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { RocketIcon, ArrowRightIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function FinalCtaSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full overflow-hidden bg-gradient-to-r from-electric-blue to-bright-orange py-20 sm:py-28" data-id="element-58">
      {/* Background decorations */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-59">
        <div className="absolute -left-20 -top-20 h-64 w-64 rounded-full bg-white/10 blur-3xl" data-id="element-60" />
        <div className="absolute -bottom-20 -right-20 h-80 w-80 rounded-full bg-white/10 blur-3xl" data-id="element-61" />
        <div className="absolute left-1/2 top-1/2 h-96 w-96 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white/5 blur-3xl" data-id="element-62" />
      </div>

      <div className="relative z-10 mx-auto max-w-4xl px-4 sm:px-6 lg:px-8" data-id="element-63">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.3
      }} className="text-center" data-id="element-64">
          {/* Icon */}
          <motion.div variants={itemVariants} className="mx-auto mb-6 inline-flex h-16 w-16 items-center justify-center rounded-full bg-white/20 backdrop-blur-sm" data-id="element-65">
            <RocketIcon className="h-8 w-8 text-white" data-id="element-66" />
          </motion.div>

          {/* Headline */}
          <motion.h2 variants={itemVariants} className="mb-6 font-heading text-3xl font-extrabold text-white sm:text-4xl md:text-5xl" data-id="element-67">
            ¿Listo para Transformar tu Negocio?
          </motion.h2>

          {/* Subtext */}
          <motion.p variants={itemVariants} className="mx-auto mb-10 max-w-2xl text-lg text-white/90 sm:text-xl" data-id="element-68">
            No esperes más. Cada día que pasa es un día que tu competencia te
            lleva ventaja. Empieza hoy y comienza a ver resultados esta misma
            semana.
          </motion.p>

          {/* CTA Button */}
          <motion.div variants={itemVariants} data-id="element-69">
            <button onClick={scrollToPricing} className="group inline-flex items-center gap-3 rounded-2xl bg-white px-8 py-5 text-xl font-bold text-electric-blue shadow-lg transition-all duration-300 hover:scale-105 hover:shadow-xl" data-id="element-70">
              Quiero Empezar Ahora
              <ArrowRightIcon className="h-6 w-6 transition-transform group-hover:translate-x-1" data-id="element-71" />
            </button>
          </motion.div>

          {/* Urgency */}
          <motion.p variants={itemVariants} className="mt-6 text-white/80" data-id="element-72">
            💡 Solo <span className="font-bold text-white" data-id="element-73">$14.99</span> —
            Precio especial por tiempo limitado
          </motion.p>
        </motion.div>
      </div>
    </section>;
}